export default "__VITE_ASSET__ezPy0mgf__"